import { shallowEqual, useSelector } from "react-redux";

const useFieldVisibility = ({ field, form, useDynamicFields = false }) => {
  const fieldVisibility = useSelector(
    (state) =>
      state.formVisibility.formVisibilityMap?.[form]?.[field] ?? {
        visible: 0,
        mandatory: 0,
        label: "",
      },
    shallowEqual,
  );

  // Grab loading flag separately if you need it
  const isLoading = useSelector((state) => state.formVisibility.loading);

  return {
    visible: fieldVisibility.visible === 1,
    mandatory: fieldVisibility.mandatory === 1,
    label: fieldVisibility.label,
    isLoading,
  };
};

export default useFieldVisibility;
